import React from 'react';
import './login-premium.css';

// Nodes sit on the dotted-map regions (left + right), leaving the centre clear for the card.
const NODES = [
  [150, 170], [260, 300], [360, 440], [470, 250], [230, 540], [560, 600],
  [1180, 230], [1310, 330], [1460, 260], [1560, 440], [1420, 560], [1680, 350],
];
const ARCS = [
  'M150 170 Q 320 60 470 250', 'M260 300 Q 420 180 560 600', 'M360 440 Q 240 420 230 540',
  'M470 250 Q 300 420 360 440', 'M1180 230 Q 1380 120 1560 440', 'M1310 330 Q 1500 220 1680 350',
  'M1460 260 Q 1360 460 1420 560', 'M1180 230 Q 1240 500 1420 560',
  'M470 250 Q 880 -60 1310 330', 'M560 600 Q 880 900 1180 230',
];
const KEY_NODES = new Set([1, 3, 5, 7, 9, 11]);

export const LoginNetworkBackdrop = ({ onLoad, loaded }) => (
  <div className="absolute inset-0 z-0 overflow-hidden lp-bg" aria-hidden="true" data-testid="login-network-backdrop">
    <img
      src="/images/titleflow-login-skyline.jpg"
      alt=""
      className="lp-bg-img w-full h-full object-cover transition-opacity duration-700"
      style={{ opacity: loaded ? 1 : 0 }}
      onLoad={onLoad}
      data-testid="login-bg-image"
    />
    <div className="absolute inset-0 lp-tint" />
    <div className="absolute inset-0 lp-floor" />
    <svg className="absolute inset-0 w-full h-full lp-net" viewBox="0 0 1760 900" preserveAspectRatio="xMidYMid slice">
      <defs>
        <linearGradient id="lpArc" x1="0" x2="1" y1="0" y2="0">
          <stop offset="0" stopColor="#60a5fa" stopOpacity="0" />
          <stop offset="0.5" stopColor="#2563eb" stopOpacity="0.85" />
          <stop offset="1" stopColor="#60a5fa" stopOpacity="0" />
        </linearGradient>
        <radialGradient id="lpGlow">
          <stop offset="0" stopColor="#ffffff" stopOpacity="1" />
          <stop offset="0.3" stopColor="#60a5fa" stopOpacity="0.55" />
          <stop offset="1" stopColor="#3b82f6" stopOpacity="0" />
        </radialGradient>
      </defs>
      {ARCS.map((d, i) => (
        <g key={i}>
          <path d={d} className="lp-arc-base" />
          {i % 2 === 0 && <path d={d} className="lp-arc-flow" style={{ animationDelay: `${i * 2.1}s`, animationDuration: `${18 + (i % 3) * 4}s` }} />}
        </g>
      ))}
      {NODES.map(([x, y], i) => (
        <g key={i} className={`lp-node ${KEY_NODES.has(i) ? 'is-key' : ''}`} style={{ animationDelay: `${(i * 1.1) % 7}s` }}>
          <circle cx={x} cy={y} r="20" fill="url(#lpGlow)" className="lp-node-halo" />
          <circle cx={x} cy={y} r="3" fill="#ffffff" stroke="#3b82f6" strokeWidth="1.2" />
        </g>
      ))}
    </svg>
  </div>
);
